import {
  FaCircleDot,
  FaBox,
  FaUsersGear,
  FaVanShuttle,
  FaFolderTree,
  FaCheckToSlot,
  FaFileCircleCheck,
  FaFileLines,
  FaFileInvoice,
  FaMoneyBill,
  FaTruck,
  FaMoneyBillTransfer,
  FaSackDollar,
  FaMoneyBillTrendUp,
  FaWallet,
} from "react-icons/fa6";
import { TbCreditCardRefund } from "react-icons/tb";
import { CiBoxList } from "react-icons/ci";
import {
  FiHome,
  FiUser,
  FiSettings,
  FiBarChart2,
  FiShoppingCart,
} from "react-icons/fi";
import { FaSitemap, FaBoxOpen } from "react-icons/fa";
import { FcOpenedFolder } from "react-icons/fc";
import { RiListSettingsFill } from "react-icons/ri";
import { MdDashboardCustomize } from "react-icons/md";
import { BiMessageCheck } from "react-icons/bi";
import { BsBank2 } from "react-icons/bs";
import { SiAmazons3 } from "react-icons/si";

/**
 * This is an array of objects, each containing properties for a link that will be displayed in the sidebar.
 * The properties are:
 * - link: The URL that the link will navigate to when clicked.
 * - name: The text that will be displayed for the link.
 * - icon: The icon that will be displayed next to the link.
 * - isActive: A boolean indicating whether the link should be displayed as active or not.
 * - subMenu: An array of objects, each containing the same properties as above, that will be displayed as a sub-menu
 *   when the link is clicked.
 */
const Links = [
  { link: "/dashboard", name: "Dashboard", icon: <FiHome size={20} />, isActive: true },
  {
    link: "/categories",
    name: "Categories",
    icon: <FaSitemap size={20} />,
    isActive: true,
  },
  {
    link: "#",
    name: "Products",
    permissionKey: "products",
    icon: <FaBoxOpen size={20} />,
    isActive: true,
    subMenu: [
      {
        link: "/products",
        name: "Products List",
        icon: <FaBoxOpen size={20} />,
        isActive: true,
      },
      {
        link: "/product-import-timeline",
        name: "Product Import Logs",
        icon: <FaBoxOpen size={20} />,
        isActive: true,
      },
      {
        link: "/product-images",
        name: "Image Manager",
        icon: <SiAmazons3 size={20} color="primary" />,
        isActive: true,
      },
    ],
  },
  {
    link: "#",
    name: "Inventory",
    permissionKey: "inventories",
    icon: <FaFolderTree size={20} />,
    isActive: true,
    subMenu: [
      {
        link: "/inventory-validate",
        name: "Inventory Validate",
        icon: <FaFileCircleCheck size={20} />,
        isActive: true,
      },
      {
        link: "/inventory-list",
        name: "Inventory List",
        icon: <FaFileLines size={20} />,
        isActive: true,
      },
      {
        link: "/inventory-timeline",
        name: "Inventory Import Logs",
        icon: <FaFileInvoice size={20} />,
        isActive: true,
      },
    ],
  },
  {
    link: "/supplier",
    name: "Suppliers",
    icon: <FaVanShuttle size={20} />,
    isActive: true,
    // subMenu: [
    //     { link: "/supplier", name: "Suppliers", icon: <FaVanShuttle size={20} />, isActive: true },
    //     // { link: "/supplier/supplier-topup-setting", name: "Supplier Topup Setting", icon: <FaVanShuttle size={20} />, isActive: true },
    // ]
  },
  {
    link: "/customers",
    name: "Customers",
    icon: <FiUser size={20} />,
    isActive: true,
  },
  // {
  //   link: "/orders",
  //   name: "Orders",
  //   icon: <FiShoppingCart size={20} />,
  //   isActive: true,
  // },
  //  {
  //   link: "/refunds",
  //   name: "Refunds",
  //   icon: <FiShoppingCart size={20} />,
  //   isActive: true,
  // },

  {
    link: "#",
    name: "Orders & Refunds",
    icon: <CiBoxList size={20} />,
    isActive: true,
    permissionKey: "orders",
    subMenu: [
      {
        name: "Orders",
        link: "/orders",
        icon: <FiShoppingCart size={20} />,
        permissionKey: "orders",
        isActive: true,
      },
      {
        name: "Refunds",
        link: "/refunds",

        icon: <TbCreditCardRefund size={20} />,
        /*
         * "orders", not "refunds".
         *
         * There is no "refunds" permission. The set a role can hold is
         * fixed -- dashboard, categories, products, inventories, supplier,
         * customers, orders, profile, employee, roles, reports,
         * customer-help-service, home-screen, cms, settings -- and
         * "refunds" is not in it, so this asked for something nobody can
         * be granted. The route has always guarded /refunds on `orders`.
         *
         * It went unnoticed because the sidebar ignored permissions on
         * submenu items altogether: the key was wrong and the link showed
         * anyway. Honouring the flag made the mismatch visible, and Mini K
         * -- who holds orders -- lost a page she is entitled to.
         */
        permissionKey: "orders",
        isActive: true,
      },
      {
        link: "/bank-transfers",
        name: "Bank Transfers",
        icon: <BsBank2 size={14} />,
        isActive: true,
      },
      // Payment Failures — orders authorised but never captured: delivered,
      // unpaid, and previously findable only by opening the exact order.
      //
      // NOT LISTED YET, on purpose. The screen and its API are complete and
      // deployed, and the route "/payment-failures" works if typed. What is not
      // yet proven is the Retry capture button, which charges a real customer's
      // card. Nothing that moves money should sit in front of the client before
      // somebody has watched it work.
      //
      // Note for whoever switches this on: `isActive` here is pointless, the
      // renderer overwrites it from the caller's permissions. Uncommenting this
      // block is what makes it appear.
      //
      // {
      //   link: "/payment-failures",
      //   name: "Payment Failures",
      //   icon: <BsBank2 size={14} />,
      //   isActive: true,
      //   permissionKey: "orders",
      // },
    ],
  },
  {
    link: "#",
    name: "Profiles",
    permissionKey: "profile",
    icon: <FaSackDollar size={20} />,
    isActive: true,
    subMenu: [
      {
        link: "/taxation",
        name: "Taxation",
        icon: <FaMoneyBillTrendUp size={20} />,
        isActive: true,
      },
      {
        link: "/service-fee",
        name: "Service Fee",
        icon: <FaMoneyBillTransfer size={20} />,
        isActive: true,
      },
      // {
      //   link: "/reports/delivery-fee",
      //   name: "Delivery Fee",
      //   icon: <FaTruck size={20} />,
      //   isActive: true,
      // },
    ],
  },
  // {
  //   link: "/reports/wallet-transactions",
  //   name: "Wallet Transactions",
  //   icon: <FaWallet size={20} />,
  //   isActive: true,
  // },
  {
    link: "/employee",
    name: "Employee List",
    icon: <FiUser size={20} />,
    isActive: true,
  },
  {
    link: "/roles",
    name: "Roles & Permissions",
    icon: <FaUsersGear size={20} />,
    isActive: true,
  },
  {
    link: "#",
    name: "Reports",
    permissionKey: "reports",
    icon: <FiBarChart2 size={20} />,
    isActive: true,
    subMenu: [
      {
        link: "/purchase",
        name: "API Transactions",
        icon: <FaCircleDot size={14} />,
        isActive: true,
      },
      // { link: "/reports/customers", name: "Customer Reports", icon: <FaCircleDot size={14} /> },
      {
        link: "/payment",
        name: "Payment Reports",
        icon: <FaCircleDot size={14} />,
        isActive: true,
      },
      {
        link: "/product-reports",
        name: "Product Reports",
        icon: <FaCircleDot size={14} />,
        isActive: true,
      },
      {
        link: "/pinlogs",
        name: "Pin Logs",
        icon: <FaCircleDot size={14} />,
        isActive: true,
      },
      // { link: "/reports/reportLogs", name: "Report Logs", icon: <FaCircleDot size={14} /> },
    ],
  },

  {
    link: "/customer-help-service",
    name: "Customer Help Service",
    icon: <BiMessageCheck size={20} />,
    isActive: true,
  },
  {
    link: "/home-screen",
    name: "Customer Home Page",
    icon: <MdDashboardCustomize size={20} />,
    isActive: true,
  },
  {
    link: "/cms",
    name: "CMS",
    icon: <RiListSettingsFill size={20} />,
    isActive: true,
    permissionKey: "cms",
  },
  {
    link: "/adminSettings",
    name: "Settings",
    icon: <FiSettings size={20} />,
    isActive: true,
    permissionKey: "settings",
  },
  /*
    Payment Gateway was here. Removed 25 Sep 2026: the Adyen credentials now
    live in .env.production on each server, not in the database, so there is
    nothing for a screen to edit. See DEV-NOTES for why. Supplier credentials
    are unaffected and still configured under Suppliers.
  */

  // { link: "/taxation", name: "Taxation on Fees", icon: <FiUser size={20} />, isActive: true },
];

export default Links;
